import { Route } from "react-router-dom";
import { pages } from "../../../utils/common";
// import { PageName } from "../../../utils/pages-helpers";
import DashboardView from "./dashboard.view";

const useDashboardRoutes = () => (
  <Route path={pages.dashboard.path} element={<DashboardView />}>
    <Route index element={<DashboardView />} />
    {/* <Route
      path={pages.dashboard.path + "/" + PageName.overview}
      element={<DashboardView />}
    /> */}
  </Route>
);

export default useDashboardRoutes;
